module.exports = __webpack_public_path__ + "static/media/phone_black4.ddc4bf1e.png";